import { render, staticRenderFns } from "./PostChart.vue?vue&type=template&id=384b1cdc&"
import script from "./PostChart.vue?vue&type=script&lang=js&"
export * from "./PostChart.vue?vue&type=script&lang=js&"
import style0 from "./PostChart.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports